import { Figure, Term } from '../services/impls/specification';

export const TermService = Symbol.for('TermService');

export interface TermService {
    setNumber(term: Term, number: string): void;
    setText(term: Term, text: string): void;
    addTerm(term: Term, head?: boolean): void;
    getFiguresByTermId(termId: string): Figure[];
}
